export function canLockPublish(
  item: { created_by?: string; created_by_uid?: string },
  userInfo: { uid?: string },
  isSystem: boolean
): boolean {
  if (isSystem) return false;
  const ownerUid = item.created_by_uid || item.created_by;
  return !!userInfo.uid && userInfo.uid === ownerUid;
}
